import React, { useState } from 'react';
import { ArrowClockwise } from '@phosphor-icons/react';
import { Button } from './ui/button';
import { getContact, retryContactFiche } from '../services/api';
import { formatApiError } from '../utils/apiError';

export const ContactFicheStatus = ({ contact, onChange, prefix = 'contact' }) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  if (!contact.fiche_status || contact.fiche_status === 'ready') return null;
  const failed = contact.fiche_status === 'failed';
  const check = async event => {
    event.stopPropagation();
    if (busy) return;
    setBusy(true); setError('');
    try {
      if (failed) await retryContactFiche(contact.id);
      const response = await getContact(contact.id);
      onChange(response.data);
    } catch (err) { setError(formatApiError(err, 'Vérification de la fiche indisponible.')); }
    finally { setBusy(false); }
  };
  return <div className="mt-1 min-w-0 space-y-1" data-testid={`${prefix}-fiche-status-${contact.id}`}>
    <div className="flex min-w-0 flex-wrap items-center gap-1">
      <span className={`text-xs ${failed ? 'text-amber-800' : 'text-[#5E6D66]'}`} role="status" data-testid={`${prefix}-fiche-label-${contact.id}`}>{failed ? 'Contact enregistré · PDF à reprendre' : 'Contact enregistré · PDF en préparation'}</span>
      <Button type="button" size="sm" variant="ghost" className="h-auto min-h-7 gap-1 px-2 py-1 text-xs" disabled={busy} onClick={check} title={failed ? 'Reprendre uniquement la fiche PDF' : 'Vérifier la fiche PDF'} data-testid={`${prefix}-fiche-refresh-${contact.id}`}>
        <ArrowClockwise size={13} className={busy ? 'animate-spin' : ''} aria-hidden="true" />{failed ? 'Reprendre' : 'Vérifier'}
      </Button>
    </div>
    {error && <p role="alert" className="break-words text-xs text-red-700" data-testid={`${prefix}-fiche-error-${contact.id}`}>{error}</p>}
  </div>;
};